import Country from '@/orm/models/Country'
import { Defaults, Options } from '@/orm/models/Setting'
import SettingsRepo from '@/orm/repositories/SettingsRepo'
import { AxiosRepository } from '@pinia-orm/axios'
import { useRepo } from 'pinia-orm'

export default class CountriesRepo extends AxiosRepository<Country> {
    use = Country

    private __iso2Cache: Map<string, string> = new Map()

    countryForSailList() {
        return this.whereNotNull('sailCode').get()
            .map((country) => ({ label: country.sailCode + ' ' + country.name, value: country.sailCode }))
            .sort((a, b) =>
                (a.value === Country.CZ_SAILCODE && b.value !== Country.CZ_SAILCODE)
                    ? -1
                    : ((a.value !== Country.CZ_SAILCODE && b.value === Country.CZ_SAILCODE)
                        ? 1
                        : a.label.localeCompare(b.label))
            )
    }

    iso2ForSailCode(sailCode) {
        if (this.__iso2Cache.has(sailCode)) {
            return this.__iso2Cache.get(sailCode) ?? ''
        }

        const country = this.where('sailCode', sailCode).first()

        const iso2 = country?.iso2?.toLowerCase() ?? ''

        this.__iso2Cache.set(sailCode, iso2)

        return iso2
    }

    countryList() {
        return this.all()
            .map((country) => ({ label: country.name, value: country.id }))
            .sort((a, b) =>
                (a.value === Country.CZ && b.value !== Country.CZ)
                    ? -1
                    : ((a.value !== Country.CZ && b.value === Country.CZ) ? 1 : a.label.localeCompare(b.label))
            )
    }

    update() {
        const authToken = useRepo(SettingsRepo).getOption(Options.AuthToken, Defaults.AuthToken)

        this.flush()
        this.__iso2Cache.clear()

        return this.api().get('/catalogs/countries', {
            headers: { Authorization: authToken.length > 0 ? 'Bearer ' + authToken : '' },
            dataTransformer: ({ data }) => {
                return data.map((line) => ({
                    id: parseInt(line.id),
                    name: String(line.name.cs),
                    iso2: String(line.iso2),
                    iso3: String(line.iso3),
                    sailCode: Object.hasOwn(line, 'sailCode') ? String(line.sailCode) : undefined,
                }))
            },
        })
    }
}
